import './snackbar.css';

import Icon from '@icons';
import { useSnackbar } from 'notistack';
/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';
import { forwardRef } from 'react';

/**
 * Componente de estilização dos Snackbars
 */
const SnackMessage = forwardRef(({ id, message, variant }, ref) => {
  const { closeSnackbar } = useSnackbar();

  const handleDismiss = () => {
    closeSnackbar(id);
  };

  /**
   * Componente Snackbar estilizado
   */
  const variantOptions = (paramVariant) => {
    if(paramVariant === 'success') {
      return (<div className="icon"><Icon i="all-snackbar-success" /></div>)
    }else if (paramVariant === 'warning') {
      return (<div className="icon"><Icon i="all-snackbar-warning" /></div>)
    }else if (paramVariant === 'error'){
      return (<div className="icon"><Icon i="all-snackbar-error" /></div>)
    }else {
      return null;
    }
  }
  return (
    <div ref={ref} className={`bodySnackbar ${variant}`}>
      <div className="content">
        {variantOptions(variant)}
        <p>{message}</p>
      </div>
      <button className="close" onClick={handleDismiss}>
        [ Fechar ]
      </button>
    </div>
  );
});

SnackMessage.propTypes = {
  /** Identificador do snackbar */
  id: PropTypes.any,
  /** Mensagem*/
  message: PropTypes.string,
  /** Variante */
  variant: PropTypes.oneOf(['success', 'warning', 'error']),
};

export default SnackMessage;
